import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\(pages)\\(general)\\products\\components\\products-view.tsx");
